import { allColors } from 'src/constants/designSystemColors';
import Text from '../Text/Text';
import { IconProps } from '@drift-labs/icons';

const RuleRow = ({
	header,
	description,
	Icon,
}: {
	header: string;
	description: React.ReactNode;
	Icon: (props: IconProps) => JSX.Element;
}) => {
	return (
		<div className="flex gap-3">
			<Icon
				size={32}
				className="min-w-[28px] min-h-[28px] max-h-[28px] max-w-[28px] sm:min-w-[32px] sm:min-h-[32px]"
			/>
			<div className="flex flex-col gap-1">
				<Text.MICRO1 style={{ color: allColors.neutrals[20] }}>
					{header}
				</Text.MICRO1>
				<Text.BODY3
					style={{ color: allColors.neutrals[0] }}
					className="leading-[16px]"
				>
					{description}
				</Text.BODY3>
			</div>
		</div>
	);
};

export default RuleRow;
